export default function StockBar({ soldPct = 60, stock, className = "" }) {
  const pct = Math.min(98, Math.max(5, soldPct));
  const critical = stock != null && stock <= 8;
  return (
    <div className={className} data-testid="stock-bar">
      <div className="flex items-center justify-between mb-1.5">
        <span className={`text-xs font-bold font-mono-tech ${critical ? "text-red-400" : "text-amber-400"}`}>
          {stock != null ? `Plus que ${stock} en stock` : `${pct}% réservé`}
        </span>
        <span className="text-xs text-stone-500 font-mono-tech">{pct}% vendu</span>
      </div>
      <div className="h-2 rounded-full bg-stone-800/80 overflow-hidden">
        <div
          className={`h-full rounded-full ${critical ? "bg-red-500" : "bg-gradient-to-r from-amber-500 to-orange-600"}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
